// Upgrades every Carousel Slider block from Swiper's default slide transition to its
// real fade effect. The plugin's block script never exposes an "effect" option, so
// once it has initialized a carousel normally, we destroy and recreate that Swiper
// instance with effect: 'fade'. This only works if the plugin's "Load Full Swiper
// Bundle" setting is enabled (Settings -> Carousel Slider) — the trimmed default
// bundle doesn't include the fade module.
//
// Note: Swiper's fade effect always shows one slide at a time (it internally forces
// slidesPerView/slidesPerGroup to 1), so any carousel configured for multiple slides
// per view will visually collapse to a single slide once faded.
//
// Runs on window "load" (after DOMContentLoaded) so the plugin's own script has
// already created the initial Swiper instance we're upgrading.
window.addEventListener('load', () => {
    if (typeof Swiper === 'undefined') {
        return;
    }

    document.querySelectorAll('.cb-carousel-block .swiper').forEach((swiperEl) => {
        const instance = swiperEl.swiper;

        if (!instance || instance.params.effect === 'fade') {
            return;
        }

        const params = {
            ...instance.params,
            effect:     'fade',
            speed:      2500,
            fadeEffect: { crossFade: true },
            // Swiper blocks slideNext()/slidePrev() while animating on loop-mode
            // by default (loopPreventsSliding: true). Disable that because our
            // fade transition is slow that the nav buttons seem unresponsive.
            loopPreventsSliding: false,
        };

        instance.destroy(true, true);
        new Swiper(swiperEl, params);
    });
});
